// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GbqU","label":"styles_label__1_OBx"};